import React from 'react';
import { Box } from '@mui/material';
import { tones } from '../../../theme/salesTheme';

// Tag: a small tinted label. tone = neutral | primary | info | success | warning | error
// | purple | dark. `dot` adds a status dot in front.
export const Tag = ({ tone = 'neutral', dot, children, sx, title }) => {
  const t = tones[tone] || tones.neutral;
  return (
    <Box
      component="span"
      title={title}
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.625, height: 22, px: 1, borderRadius: '6px',
        bgcolor: t.bg, color: t.fg, fontSize: '0.72rem', fontWeight: 600, lineHeight: 1, whiteSpace: 'nowrap', ...sx
      }}
    >
      {dot && <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: t.dot, flexShrink: 0 }} />}
      {children}
    </Box>
  );
};

const AVATAR_TONES = ['primary', 'purple', 'success', 'warning', 'info', 'error'];

const hash = (s) => {
  let h = 0;
  for (let i = 0; i < String(s).length; i += 1) h = (h * 31 + String(s).charCodeAt(i)) % 9973;
  return h;
};

// Initials: a round tinted avatar with a person's initials (colour is stable per seed).
export const Initials = ({ name, seed, size = 32 }) => {
  const t = tones[AVATAR_TONES[hash(seed || name || '') % AVATAR_TONES.length]];
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  const text = words.length ? (words[0][0] + (words[1] ? words[1][0] : '')).toUpperCase() : '';
  return (
    <Box
      sx={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
        bgcolor: text ? t.bg : '#F1F3F6', color: text ? t.fg : '#98A2B3', fontSize: size * 0.36, fontWeight: 700, letterSpacing: '0.02em'
      }}
    >
      {text || (
        <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.3 0-8 1.7-8 5v1h16v-1c0-3.3-4.7-5-8-5Z" />
        </svg>
      )}
    </Box>
  );
};

// Plan tiers get their own tone so a list can be scanned by plan.
export const planTone = (plan, active) => {
  if (!active) return 'neutral';
  switch (String(plan || '').toLowerCase()) {
    case 'black': return 'dark';
    case 'elite': return 'purple';
    case 'plus': return 'primary';
    default: return 'success';
  }
};
